// Перевод кодов ошибок сервера в ключи словаря. Сервер отдаёт коды, а не
// готовые фразы: интерфейс живёт на пяти языках.
import type { ApiError } from './api';

const KNOWN = new Set([
  'invalid_credentials',
  'invalid_email',
  'weak_password',
  'email_taken',
  'blocked',
  'rate_limited',
  'bad_token',
  'unauthorized',
  'forbidden',
  'self_change',
  // Часть действий закрыта, пока администратор работает «от имени» другого:
  // менять пароль и удалять аккаунт может только его владелец.
  'impersonating',
  'origin',
  'network',
  // AuthModal перехватывает 'restorable' раньше и уводит на отдельный экран
  // восстановления — этот ключ здесь только на случай, если код всплывёт
  // где-то ещё (например в общем обработчике ошибок).
  'restorable',
]);

export function errorKey(error: ApiError | null | undefined): string {
  if (!error) return 'auth.err.unknown';
  return KNOWN.has(error.error) ? `auth.err.${error.error}` : 'auth.err.unknown';
}

const PROBLEMS = new Set(['short', 'long', 'common', 'same_as_email']);

/** Подробности «пароль не годится»: короткий, слишком простой и т. п. */
export function passwordProblemKeys(problems: string[] | undefined): string[] {
  if (!problems?.length) return [];
  return problems.filter((p) => PROBLEMS.has(p)).map((p) => `auth.pw.${p}`);
}
